import {IDepotResUiEnv, IDepotUiEnv} from "lib/store/depot";
import {IReg, REG} from "lib/commons/registry";
import {DOM, JSX} from "lib/commons/xml/dom";
import {JNodeInfos, URLTREE} from "lib/store/urlTree";
import {ButtonActions, OButtonActionsInit} from "back/commons/widgets/buttons";
import {Action, IAction, IActionToggle} from "lib/commons/actions";
import {InfoFocusRes} from "lib/store/res";
import {LOCALE} from "lib/commons/lang";


/**
 * Affiche un popup de sélection d'une version issu de l'historique des nodeInfos.
 */
export interface ResVersionsView extends ButtonActions<ResVersionsView> {
	initialize(init: OResVersionsViewInit): this
}

export interface OResVersionsViewInit extends OButtonActionsInit<ResVersionsView> {
	showDate?: boolean
	/** Restreint la liste des versions aux changements de content (contentId du resId !=). */
	onlyChangedContent?: boolean
	//listenHistChanges?: boolean
}

export class ResVersionsView extends ButtonActions<ResVersionsView> {
	reg: IReg<IDepotResUiEnv & IDepotUiEnv>;
	showDate?: boolean
	onlyChangedContent?: boolean

	protected _initialize(init: OResVersionsViewInit) {
		this.reg = this.findReg(init);
		super._initialize(init);
		this.reg.installSkin(this.localName, this.shadowRoot);
		this.showDate = init.showDate;
		this.onlyChangedContent = init.onlyChangedContent;
		//if (init.listenHistChanges)
		this.reg.env.nodeInfosChange?.on("histChange", (this._histLstn = () => {this.refresh()}));
	}

	protected _histLstn: (niNew: JNodeInfos) => void;

	protected _refresh() {
		const env = this.reg.env;
		if (env.nodeInfos) {
			//console.log("ResVersionsView.nodeInfos:::", env.nodeInfos);
			this._label = this.buildVersionName(env.nodeInfos);
			const actions = [];
			let ni = env.nodeInfos;
			while (ni.succ && ni.succ[0]) {
				ni = ni.succ[0];
				actions.push(new GotoNode(ni));
			}
			actions.reverse();
			actions.push(new ThisNode(env.nodeInfos));
			if (env.nodeInfos.hist) for (let node of env.nodeInfos.hist) {
				actions.push(new GotoNode(node));
			}

			if (this.onlyChangedContent) {
				let filteredActions: IAction<ResVersionsView>[] = [];
				actions.reduce<string>((contentId: string, currentValue: GotoNode) => {
					const resId = currentValue.ni.resId;
					if (!resId.startsWith(contentId)) {
						//nouveau contentId trouvé
						contentId = resId.substring(0, ni.resId.length - 3); //contentId.
						filteredActions.push(currentValue);
					} else if (currentValue instanceof ThisNode) {
						//Pas nouveau contentId, mais noeud this, on garde.
						filteredActions.push(currentValue);
					}
					return contentId;
				}, "-");
				this.actions = filteredActions;
			} else {
				this.actions = actions;
			}
		} else if (env.nodeInfosPending) {
			env.nodeInfosPending.then(this.refresh.bind(this));
			return;
		} else {
			//Pas de nodeInfos, ni de chargement en cours => erreur
			this._label = "?";
			this.actions = [];
		}
		this.disabled = this._actions.length < 1;
		const notHead = env.nodeInfos?.succ?.length > 0;
		this.classList.toggle("notHead", notHead);
		DOM.setAttr(this, "title", notHead ? "Attention, cette version n'est pas la dernière" : null);
		super._refresh();
	}

	onViewHidden(closed?: boolean) {
		if (closed && this._histLstn) {
			this.reg.env.nodeInfosChange?.removeListener("histChange", this._histLstn);
		}
	}

	buildVersionName(ni: JNodeInfos) {
		const version = ni.v || "";
		if (this.showDate && ni.m) {
			const date = LOCALE.formatDateDigitsToSec.format(ni.m);
			return `Version ${version} du ${date}`;
		}
		return ni.v || "\u00A0";
	}
}

class GotoNode extends Action<ResVersionsView> {

	constructor(public ni: JNodeInfos) {super();}

	getIcon(ctx: ResVersionsView): string {
		return ctx.reg.env.resTypes.getResTypeFor(this.ni).resIcon(this.ni);
	}

	getLabel(ctx: ResVersionsView): string {
		return ctx.buildVersionName(this.ni);
	}

	execute(ctx: ResVersionsView, ev?: Event): any {
		ctx.reg.env.infoBroker.dispatchInfo(new InfoFocusRes(URLTREE.switchLeafVersionPath(ctx.reg.env.nodeInfos.permaPath, this.ni.v || this.ni.idx)), ctx);
	}
}

class ThisNode extends GotoNode {
	isToggle(ctx: ResVersionsView): this is IActionToggle<ResVersionsView> {return true}

	getDatas(api: "menu" | "toggle" | string, ctx: ResVersionsView): any {return api === "toggle" ? true : null}

	isEnabled(ctx: ResVersionsView): boolean {return false}
}

REG.reg.registerSkin('store-res-versions', 1, /* language=CSS */ `
	:host(.notHead) > span {
		padding-inline-start: 1.5em;
		background: url(/@skin@/store/views/resViews/notHead.svg) no-repeat left / contain;
	}
`);

customElements.define('store-res-versions', ResVersionsView);